import { parsePickupPointFieldValue } from './pickupPoint.js'

export function getPickupPointFieldInput(pickupPointFieldId) {
  if (!pickupPointFieldId) {
    return null
  }

  return document.querySelector(`#additional_${pickupPointFieldId}, [name="additional_${pickupPointFieldId}"]`)
}

export function getPickupPointFieldInputValue(shipmentSettings) {
  const pickupPointFieldInput = getPickupPointFieldInput(shipmentSettings?.pickupPointFieldId)

  return String(pickupPointFieldInput?.value ?? '').trim()
}

export function setPickupPointFieldInputValue(shipmentSettings, value, { dispatchChange = true } = {}) {
  const pickupPointFieldInput = getPickupPointFieldInput(shipmentSettings?.pickupPointFieldId)
  if (!pickupPointFieldInput || pickupPointFieldInput.value === value) {
    return
  }

  pickupPointFieldInput.value = value
  if (dispatchChange) {
    pickupPointFieldInput.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

export function findPickupPointField(additionalFields, pickupPointFieldId) {
  const hiddenFields = additionalFields?.hiddenFields ?? []

  return hiddenFields.find(
    (field) => Number.parseInt(String(field.id), 10) === Number.parseInt(String(pickupPointFieldId), 10),
  )
}

export function readPickupPointFromAdditionalField(shipmentSettings, basketAdditionalFieldsApi) {
  if (!shipmentSettings?.pickupPointFieldId || !basketAdditionalFieldsApi?.get) {
    return null
  }

  const additionalFields = basketAdditionalFieldsApi.get()
  const pickupPointField = findPickupPointField(additionalFields, shipmentSettings.pickupPointFieldId)
  const fieldInput = getPickupPointFieldInput(shipmentSettings.pickupPointFieldId)
  const apiFieldValue = String(pickupPointField?.value ?? '').trim()
  const inputFieldValue = String(fieldInput?.value ?? '').trim()
  const fieldValue = inputFieldValue !== '' ? inputFieldValue : apiFieldValue

  return parsePickupPointFieldValue(fieldValue)
}
